document.addEventListener("DOMContentLoaded", () => {
  const bis_form = document.querySelector(".notify-form");
  const messageContainer = document.querySelector(".pdp-sold-out-form__form .form-message");
  if (!bis_form || !messageContainer) return;

  const companyId = bis_form.getAttribute("data-klaviyo-api-key");
  const productID = bis_form.getAttribute("data-product-id");

  // Best: set this in markup: data-locale="{{ request.locale.iso_code }}-{{ localization.country.iso_code }}"
  const bis_locale =
    bis_form.getAttribute("data-locale") ||
    window?.Shopify?.locale ||
    document.documentElement.lang ||
    "en-GB";

  const emailInput = bis_form.querySelector('input[type="email"]');
  const notifyButton = bis_form.querySelector("button");

  notifyButton.addEventListener("click", async (e) => {
    e.preventDefault();

    const email = (emailInput?.value || "").trim();
    if (!email) {
    	//messageContainer.textContent = "Please enter your email address.";
      	messageContainer.textContent = bis_form.getAttribute("data-email-placeholder");
      	return;
    }

    notifyButton.textContent = "Sending...";
    notifyButton.disabled = true;

    const headers = {
      revision: "2024-07-15",
      "Content-Type": "application/json",
      Accept: "application/json",
    };

    try {
      // 1) Upsert profile w/ locale (THIS is where properties are allowed)
      const profileRes = await fetch(
        `https://a.klaviyo.com/client/profiles/?company_id=${encodeURIComponent(companyId)}`,
        {
          method: "POST",
          headers,
          body: JSON.stringify({
            data: {
              type: "profile",
              attributes: {
                email,
                properties: {
                  locale: bis_locale,
                },
              },
            },
          }),
        }
      );

      // It's ok if this fails sometimes, but let's surface a useful message
      if (!profileRes.ok) {
        const profileData = await profileRes.json().catch(() => null);
        throw new Error(
          profileData?.errors?.[0]?.detail || `Profile request failed (${profileRes.status})`
        );
      }

      // 2) Create BIS subscription (email only - NO properties here)
      const bisRes = await fetch(
        `https://a.klaviyo.com/client/back-in-stock-subscriptions/?company_id=${encodeURIComponent(companyId)}`,
        {
          method: "POST",
          headers,
          body: JSON.stringify({
            data: {
              type: "back-in-stock-subscription",
              attributes: {
                channels: ["EMAIL"],
                profile: {
                  data: {
                    type: "profile",
                    attributes: { email },
                  },
                },
              },
              relationships: {
                variant: {
                  data: {
                    type: "catalog-variant",
                    id: `$shopify:::$default:::${productID}`,
                  },
                },
              },
            },
          }),
        }
      );

      if (bisRes.status === 202) {
        //messageContainer.textContent = "Success! You will be notified when the product is back in stock.";
        messageContainer.textContent = bis_form.getAttribute("data-form-success-message");
        emailInput.value = "";
      } else {
        const bisData = await bisRes.json().catch(() => null);
        throw new Error(
          bisData?.errors?.[0]?.detail || `Subscription request failed (${bisRes.status})`
        );
      }
    } catch (err) {
      messageContainer.textContent = `Error: ${err.message || "Unable to process your request."}`;
    } finally {
      notifyButton.textContent = bis_form.getAttribute("data-form-button-text");
      notifyButton.disabled = false;
    }
  });
});